export enum commandMessage {
  closeContainer = 'command_close_container', //关闭容器
  liveCall =  'command_live_call', //发起通话
  cardCall = 'command_card_call', //学生证通话
  getToken = 'command_get_token', //获取token
  jumpPage = 'command_jump_page', //跳转页面
  commandLogout = 'command_logout', //注销登录
  openNewContainer = 'command_new_container', //打开一个新的容器
  getCommandData = 'command_get_data' //获取app数据
}